import React, { useEffect } from 'react';
import { LogoutPageContent } from 'services/content';
import styles from './style.module.css';
import { useHistory } from 'react-router-dom';
import { AUTH_LOGOUT } from '../../helpers/types';
import { useDispatch } from 'react-redux';

const Logout = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: AUTH_LOGOUT });
  }, [dispatch]);

  return (
    <div className="coop-l-container">
      <div id="logout_page" className={`${styles.logout_page} coop-l-medium-8 coop-l-large-6`}>
        <h1>{LogoutPageContent.headingText}</h1>
        <p className={styles.intro_text}>{LogoutPageContent.subHeadingText}</p>
        <button
          className={`coop-btn coop-btn--primary ${styles.button}`}
          type="button"
          onClick={() => history.push('/pharmacy/login')}
          id="loginLink">
          {LogoutPageContent.loginButtonText}
        </button>
        <div>
          <a href={`mailto:${LogoutPageContent.email}`}>{LogoutPageContent.contactLinkText}</a>
        </div>
      </div>
    </div>
  );
};

export default Logout;
